export default __webpack_public_path__ + "static/media/lake-custom.7b8f6f01.png";